// Single source of truth for which roles can see / visit each route.
// Import from both Sidebar (for hiding) and App.js (for route gating).

export const ROLES = {
  admin: 'admin',
  teacher: 'teacher',
  parent: 'parent',
  student: 'student'
};

// Convenience role sets. Treat parent and student as the same audience —
// in this app a parent logs in on behalf of one or more students.
const ALL     = [ROLES.admin, ROLES.teacher, ROLES.parent, ROLES.student];
const STAFF   = [ROLES.admin, ROLES.teacher];
const ADMIN   = [ROLES.admin];
const FAMILY  = [ROLES.parent, ROLES.student];

// path -> allowed roles
export const ROUTE_ACCESS = {
  '/dashboard':      ALL,
  '/analytics':      ADMIN,

  // People
  '/students':       STAFF,
  '/teachers':       ADMIN,
  '/admissions':     ADMIN,

  // Academics
  '/attendance':     ALL,
  '/marks':          ALL,
  '/homework':       ALL,
  '/timetable':      ALL,
  '/question-bank':  STAFF,
  '/lesson-plans':   STAFF,

  // School
  '/events':         ALL,
  '/announcements':  ALL,
  '/circulars':      ALL,
  '/library':        [...STAFF, ...FAMILY],
  '/transport':      [...STAFF, ...FAMILY],
  '/gallery':        ALL,
  '/visitors':       ADMIN,

  // Welfare
  '/health':         [...STAFF, ...FAMILY],
  '/achievements':   ALL,
  '/leaves':         [...STAFF, ...FAMILY],
  '/student-diary':  ALL,
  '/feedback':       ALL,

  // Staff
  '/staff-attendance': ADMIN,

  // Finance
  '/expenses':         ADMIN,

  // Tools
  '/generators':     ADMIN,
  '/settings':       ADMIN,
};

export function canAccess(role, path) {
  const allowed = ROUTE_ACCESS[path];
  if (!allowed) return true; // unknown paths (deep links) fall through
  return allowed.includes(role);
}
